let _Capacitor;
try {
  _Capacitor = require('@capacitor/core').Capacitor;
} catch {
  _Capacitor = null;
}

export const isNative = () => Boolean(_Capacitor?.isNativePlatform?.());
export const getPlatform = () => _Capacitor?.getPlatform?.() ?? 'web';
export const isIOS = () => getPlatform() === 'ios';
export const isAndroid = () => getPlatform() === 'android';
export const isWeb = () => getPlatform() === 'web';
